import { Modal } from 'antd';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  width: 700px !important;

  max-width: 90vw;
  .ant-modal-content {
    background: ${({ theme }) => theme.colors.neutral.primary[5]} !important;
    padding: 0 !important;
  }

  .ant-modal-footer {
    display: none;
  }
  .ant-modal-close {
    color: red;
  }

  .ant-modal-header {
    background: ${({ theme }) => theme.colors.neutral.primary[5]} !important;
    padding: 20px 24px;
    border-bottom: 1px solid #c0c0c0;
    display: flex;
    align-items: center;
  }
`;
